"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndicatorLayout = void 0;
var utils_1 = require("../../utils");
exports.IndicatorLayout = {
  name: 'IndicatorLayout',
  label: 'Indicator Layout',
  type: 'taxonomy',
  icon: function (_a) {
    var icons = _a.icons;
    return icons.Entities.BlockLayout;
  },
  autoRoutes: ['list', 'create', 'update'],
  table: {
    fieldNames: ["preview", "name", "component", "weight"],
    fields: {
      component: {
        weight: 1.5
      },
      preview: {
        weight: 1.5
      },
      weight: {
        weight: 0.5
      }
    }
  },
  valueImageStyle: 'banner',
  list: {
    resultsVariant: 'table'
  },
  form: {
    fields: __assign(__assign({}, utils_1.entityStandardFormFields), {
      preview: {
        type: 'image',
        description: "Provide a screenshot of the design of this {{INDICATOR_LAYOUT}}, for reference."
      },
      description: {
        type: 'longText',
        description: "Describe this {{INDICATOR_LAYOUT}}."
      },
      component: {
        type: 'text',
        monospace: true,
        description: 'Which front-end component is used to render this {{INDICATOR_LAYOUT}}? If not specified, this will be \'IndicatorLayout\' followed by the \'TitleCase\' form of the name. Note: this setting indicates to website developers which component will display the information in the {{INDICATOR}} or {{INDICATOR_RESULT}} using it'
      },
      weight: {
        type: 'int',
        description: 'Enter a weighting for how much space this {{INDICATOR_LAYOUT}} would take up in a grid of multiple layouts. e.g., a weight of 1 (default) would take up 1 block of space, 2 would take up 2 blocks.'
      }
    })
  }
};